import { Mapper } from "../../../../base/utils/mapper";
import { StateCivilModel } from "../../../../domain/models/configuration/state-civil.model";
import { StateCivilEntity } from "../entities/state-civil.entity";


export class StateCivilImplementationRepositoryMapper extends Mapper<StateCivilEntity, StateCivilModel> {
    mapFrom(param: StateCivilEntity): StateCivilModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: StateCivilModel): StateCivilEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}